import { COLOR, line } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'HT_TRENDMODE',
  version: 1,
  label: 'Hilbert Trend vs Cycle Mode',
  pane: 'sub',
  category: 'cycles',
  series: 'normal',
  precision: 0,
  order: 70,
  inputs: [],
  outputs: [line('trendmode', 'Trend mode', COLOR.teal)],
  range: { min: 0, max: 1 },
  talib: { functions: ['HT_TRENDMODE'], expr: 'HT_TRENDMODE(close)' },
  listed: true,
  tailSafe: true,
  // TA_HT_TRENDMODE_Lookback: 32 for the Hilbert engine + 31 "to be compatible with Tradestation".
  lookback: () => 63,
}
export default def
